import { MockApiClient } from '@/mock/MockApiClient'

import type { ApiClient, ApiClientKind } from './client'
import { HttpApiClient } from './HttpApiClient'

export type { ApiClient, ApiClientKind } from './client'
export { ApiClientProvider, useApiClient } from './ApiClientProvider'
export { HttpApiClient } from './HttpApiClient'

/**
 * `VITE_API_CLIENT` picks the client. Unset, a production build talks to the
 * real API and everything else runs on the demo tenant, so `npm run dev` works
 * with no backend at all.
 *
 * The HTTP client answers every section without a real data source with
 * `NotLiveApiClient` — empty, and badged "Not live yet" — never with demo
 * figures, however it is built: `VITE_API_CLIENT=http npm run dev` shows what
 * production shows. Demo data belongs to the mock client alone.
 */
export function createApiClient(
  kind: ApiClientKind = import.meta.env.VITE_API_CLIENT ?? (import.meta.env.PROD ? 'http' : 'mock'),
): ApiClient {
  return kind === 'http' ? new HttpApiClient() : new MockApiClient({ latencyMs: 180 })
}
